// @flow
import {ActiveExhibitions} from "./types";
import {withLanguage} from "../../helpers/parse";

export const parseActiveExhibitions: ActiveExhibitions = (datum, language) => {
    if (!datum) return;
    return {
        id: datum.get('id'),
        coorganizationIds: datum.get('coorganizationIds'),
        isCoorganization: datum.get('isCoorganization'),
        coorganizationId: datum.get('coorganizationId'),
        mainExhibitionId: datum.get('mainExhibitionId'),
        title: withLanguage(language)(datum.get('title'))
    }
}